import { extend } from 'lodash';
import Observable from 'lib/ObservableMixin.js';

export default class SelfServiceGateway {
  constructor({ xhr }) {
    this.xhr = xhr;
  }

  configure({ orgDomain, orgId }) {
    this.orgDomain = orgDomain;
    this.orgId = orgId;
  }

  updateSelectedAnswer(answerId) {
    const url = `${this.orgDomain}/api/v1/orgs/${this.orgId}/answers/${answerId}`;
    this.xhr.get(url, { json: true }, (err, request) => {
      if (err) {
        this.notifyObservers('handleError', { reason: 'CONNECTION_ERROR', err });
        return;
      }

      if (request.statusCode !== 200) {
        this.notifyObservers('handleError', {
          reason: request.statusCode,
          err: request.body.message,
        });
        return;
      }

      this.notifyObservers('handleUpdateSelectedAnswerSuccess', request.body);
    });
  }

  getSearchResults(searchText) {
    this.xhr.get(
      `${this.orgDomain}/api/v1/orgs/${this.orgId}/answers?q=${encodeURI(searchText)}`,
      { json: true },
      (err, request) => {
        if (err) {
          this.notifyObservers('handleError', { reason: 'CONNECTION_ERROR', err });
          return;
        }

        if (request.statusCode !== 200) {
          this.notifyObservers('handleError', {
            reason: request.statusCode,
            err: request.body.message,
          });
          return;
        }

        this.notifyObservers('handleUpdateSearchResults', request.body);
      }
    );
  }
}

extend(SelfServiceGateway.prototype, Observable);
